const POST_ACTIONS = {
    CLOSE: 'close',
    PLAY: 'play',
    DEPOSIT: 'deposit',
    REGISTRATION_COMPLETED: 'RegistrationCompleted',
    TERMINATE: 'terminate'
}

export { POST_ACTIONS };